import ConstantHelper from "~helpers/ConstantHelper";

export const chatbotInputTypes = {
  Email: "Email",
  AlphaNumeric: "Alpha Numeric",
  Numbers: "ON",
};

export const chatbotSender = {
  Bot: "BOT",
  Agent: "AGENT",
};

export const chatbotActionMinContrastLimit = 2.25;
export const chatbotTerminateTimeoutSec = 900;
export const chatbotTerminateModalCountdownSec = 60;
export const chatbotPingPongIntervalMs = 10000;
export const chatbotNoMessageWarningTryCount = 10;
export const chatbotNoMessageWarningDelayMs = 1000;
export const chatbotWelcomeMsgDisappearMs = 5000;
export const chatbotPopupCollapseExpandMs = 150;
export const chatbotMaxFileUploadSize = 10 * 1024 * 1024;
export const chatbotTypingThrottleMs = 5000;
export const getChatbotPingPongMaxTimeoutMs = (ms) => ms * 4 * 1000;
export const defaultMobileModeChatbotWidth = 768;

export const chatbotSessionStatus = {
  /** @type {"new"} */
  NEW: "new",
  /** @type {"BW"} */
  BOT_WAIT: "BW",
  /** @type {"BC"} */
  BOT_CHAT: "BC",
  /** @type {"BM"} */
  BOT_MISS: "BM",
  /** @type {"AW"} */
  AGENT_WAIT: "AW",
  /** @type {"BCAW"} */
  BOT_CHAT_AGENT_WAIT: "BCAW",
  /** @type {"BR"} */
  BOT_REPLY: "BR",
  /** @type {"AS"} */
  AGENT_STARTED: "AS",
  /** @type {"AC"} */
  AGENT_CHAT: "AC",
  /** @type {"AM"} */
  AGENT_MISS: "AM",
  /** @type {"WT"} */
  WHATSAPP_TIMEOUT: "WT",
  /** @type {"FB"} */
  FEEDBACK: "FB",
  /** @type {"TI"} */
  TICKET: "TI",
  /** @type {"TO"} */
  TIMEOUT: "TO",
  /** @type {"FA"} */
  FAILED: "FA",
  /** @type {"CL"} */
  CLOSED: "CL",
  /** @type {"CO"} */
  COMPLETED: "CO",
  /** @type {"DC"} */
  CUSTOMER_DISCONNECT: "DC",
  /** @type {"BJ"} */
  BOT_JOINED: "BJ",
  /** @type {"TK"} */
  TOKEN: "TK",
  /** @type {"ESW"} Extended Session Waiting */
  ESW: "ESW",
  /** @type {"ESR"} Extended Session Responded */
  ESR: "ESR",
  /** @type {"CFW"} Closing Form Waiting */
  CLOSING_FORM_WAIT: "CFW",
};

export const chatbotSessionStatusMap = {
  [chatbotSessionStatus.NEW]: "New",
  [chatbotSessionStatus.BOT_WAIT]: "Bot Waiting",
  [chatbotSessionStatus.BOT_CHAT]: "Bot Chatting",
  [chatbotSessionStatus.BOT_MISS]: "Bot Missed",
  [chatbotSessionStatus.AGENT_WAIT]: "Agent Waiting",
  [chatbotSessionStatus.AGENT_STARTED]: "Agent Started",
  [chatbotSessionStatus.AGENT_CHAT]: "Agent Chatting",
  [chatbotSessionStatus.AGENT_MISS]: "Agent Missed",
  [chatbotSessionStatus.WHATSAPP_TIMEOUT]: "WhatsApp Timeout",
  [chatbotSessionStatus.FEEDBACK]: "Feedback",
  [chatbotSessionStatus.TICKET]: "Ticket",
  [chatbotSessionStatus.TIMEOUT]: "Timeout",
  [chatbotSessionStatus.FAILED]: "Failed",
  [chatbotSessionStatus.CLOSED]: "Closed",
  [chatbotSessionStatus.COMPLETED]: "Completed",
  [chatbotSessionStatus.CUSTOMER_DISCONNECT]: "Customer Disconnected",
  [chatbotSessionStatus.ESW]: "Extended Session Waiting",
  [chatbotSessionStatus.ESR]: "Extended Session Responded",
  [chatbotSessionStatus.CLOSING_FORM_WAIT]: "Closing Form Waiting",
};

export const chatbotSessionStatusOptions = [
  { value: chatbotSessionStatus.NEW, label: chatbotSessionStatusMap[chatbotSessionStatus.NEW] },
  { value: chatbotSessionStatus.BOT_WAIT, label: chatbotSessionStatusMap[chatbotSessionStatus.BOT_WAIT] },
  { value: chatbotSessionStatus.BOT_CHAT, label: chatbotSessionStatusMap[chatbotSessionStatus.BOT_CHAT] },
  { value: chatbotSessionStatus.BOT_MISS, label: chatbotSessionStatusMap[chatbotSessionStatus.BOT_MISS] },
  { value: chatbotSessionStatus.AGENT_STARTED, label: chatbotSessionStatusMap[chatbotSessionStatus.AGENT_STARTED] },
  { value: chatbotSessionStatus.AGENT_WAIT, label: chatbotSessionStatusMap[chatbotSessionStatus.AGENT_WAIT] },
  { value: chatbotSessionStatus.AGENT_CHAT, label: chatbotSessionStatusMap[chatbotSessionStatus.AGENT_CHAT] },
  { value: chatbotSessionStatus.AGENT_MISS, label: chatbotSessionStatusMap[chatbotSessionStatus.AGENT_MISS] },
  {
    value: chatbotSessionStatus.WHATSAPP_TIMEOUT,
    label: chatbotSessionStatusMap[chatbotSessionStatus.WHATSAPP_TIMEOUT],
  },
  { value: chatbotSessionStatus.FEEDBACK, label: chatbotSessionStatusMap[chatbotSessionStatus.FEEDBACK] },
  { value: chatbotSessionStatus.TICKET, label: chatbotSessionStatusMap[chatbotSessionStatus.TICKET] },
  { value: chatbotSessionStatus.TIMEOUT, label: chatbotSessionStatusMap[chatbotSessionStatus.TIMEOUT] },
  { value: chatbotSessionStatus.FAILED, label: chatbotSessionStatusMap[chatbotSessionStatus.FAILED] },
  { value: chatbotSessionStatus.CLOSED, label: chatbotSessionStatusMap[chatbotSessionStatus.CLOSED] },
  { value: chatbotSessionStatus.COMPLETED, label: chatbotSessionStatusMap[chatbotSessionStatus.COMPLETED] },
  {
    value: chatbotSessionStatus.CUSTOMER_DISCONNECT,
    label: chatbotSessionStatusMap[chatbotSessionStatus.CUSTOMER_DISCONNECT],
  },
  { value: chatbotSessionStatus.ESW, label: chatbotSessionStatusMap[chatbotSessionStatus.ESW] },
  { value: chatbotSessionStatus.ESR, label: chatbotSessionStatusMap[chatbotSessionStatus.ESR] },
  {
    value: chatbotSessionStatus.CLOSING_FORM_WAIT,
    label: chatbotSessionStatusMap[chatbotSessionStatus.CLOSING_FORM_WAIT],
  },
];
export const chatbotSessionDashboardStatus = {
  QUEUE: "QUE",
  INPROGRESS: "INP",
  CLOSED: "CLO",
  FAIL: "FAI",
};
export const chatbotSenderType = {
  bot: "BOT",
  agent: "AGENT",
  customer: "CUSTOMER",
  system: "SYSTEM",
};

export const chatbotMainSessionStatusList = [
  chatbotSessionStatus.AGENT_WAIT,
  chatbotSessionStatus.AGENT_CHAT,
  chatbotSessionStatus.BOT_CHAT_AGENT_WAIT,
  chatbotSessionStatus.ESW,
  chatbotSessionStatus.CLOSING_FORM_WAIT,
];

export const chatbotHistoryPageSize = 10;
export const chatbotLivechatPageSize = 10;
export const chatbotLivechatPageThrottleMs = 3000;
export const chatbotLivechatPageRefreshIntervalMs = 30000;

export const [chatbotInputRequestType, chatbotInputRequestTypeOptions, chatbotInputRequestTypeMap] =
  ConstantHelper.typify({
    /** @type {"phone_number"} */
    phone_number: "Phone Number",
    /** @type {"email"} */
    email: "Email",
    /** @type {"text"} */
    text: "Text",
    /** @type {"only_numbers"} */
    only_numbers: "Only Numbers",
    /** @type {"range"} */
    range: "Range",
    /** @type {"date"} */
    date: "Date",
    /** @type {"date_range"} */
    date_range: "Date Range",
    /** @type {"file"} */
    file: "File",
    /** @type {"select"} */
    select: "Select",
    /** @type {"custom"} */
    custom: "Custom",
    /** @type {"captcha"} */
    captcha: "Captcha",
    /** @type {"form"} */
    form: "Form",
    /** @type {"location"} */
    location: "Location",
  });

export const chatbotChatMessageToolbarEvent = "chatMessageToolbarEvent";

export const chatbotLikeDislikeType = {
  initial: 0, // Empty state (no like/dislike)
  unknown: 1, // Custom value(not related server)
  like: 2, // Like
  dislike: 3, // Dislike
  invisible: 4, // Custom value(not related server)
};

export const [chatbotGupshupTemplateType, chatbotGupshupTemplateTypeOptions, chatbotGupshupTemplateTypeMap] =
  ConstantHelper.typify({
    TEXT: window.t("constants.chatbotGupshupTemplateType.text"),
    IMAGE: window.t("constants.chatbotGupshupTemplateType.image"),
    DOCUMENT: window.t("constants.chatbotGupshupTemplateType.document"),
    VIDEO: window.t("constants.chatbotGupshupTemplateType.video"),
    LOCATION: window.t("constants.chatbotGupshupTemplateType.location"),
  });

export const [chatbotGupshupCategory, chatbotGupshupCategoryOptions, chatbotGupshupCategoryMap] = ConstantHelper.typify(
  {
    MARKETING: window.t("constants.chatbotGupshupCategory.marketing"),
    UTILITY: window.t("constants.chatbotGupshupCategory.utility"),
    AUTHENTICATION: window.t("constants.chatbotGupshupCategory.authentication"),
  }
);

export const [chatbotGupshupButtonType, chatbotGupshupButtonTypeOptions, chatbotGupshupButtonTypeMap] =
  ConstantHelper.typify({
    QUICK_REPLY: window.t("constants.chatbotGupshupButtonType.quickReply"),
    PHONE_NUMBER: window.t("constants.chatbotGupshupButtonType.phoneNumber"),
    URL: window.t("constants.chatbotGupshupButtonType.url"),
  });
export const [chatbotGupshupTemplateStatus, chatbotGupshupTemplateStatusOptions, chatbotGupshupTemplateStatusMap] =
  ConstantHelper.typify({
    PENDING: window.t("constants.chatbotGupshupTemplateStatus.pending"),
    REJECTED: window.t("constants.chatbotGupshupTemplateStatus.rejected"),
    APPROVED: window.t("constants.chatbotGupshupTemplateStatus.approved"),
    DELETED: window.t("constants.chatbotGupshupTemplateStatus.deleted"),
    DISABLED: window.t("constants.chatbotGupshupTemplateStatus.disabled"),
  });
export const [chatbotGupshupLanguage, chatbotGupshupLanguageOptions, chatbotGupshupLanguageMap] = ConstantHelper.typify(
  {
    af: window.t("constants.languages.afrikaans"),
    sq: window.t("constants.languages.albanian"),
    ar: window.t("constants.languages.arabic"),
    az: window.t("constants.languages.azerbaijani"),
    bn: window.t("constants.languages.bengali"),
    bg: window.t("constants.languages.bulgarian"),
    ca: window.t("constants.languages.catalan"),
    zh_CN: window.t("constants.languages.chineseCHN"),
    zh_HK: window.t("constants.languages.chineseHKG"),
    zh_TW: window.t("constants.languages.chineseTAI"),
    hr: window.t("constants.languages.croatian"),
    cs: window.t("constants.languages.czech"),
    da: window.t("constants.languages.danish"),
    nl: window.t("constants.languages.dutch"),
    en: window.t("constants.languages.english"),
    en_GB: window.t("constants.languages.englishUK"),
    en_US: window.t("constants.languages.englishUS"),
    et: window.t("constants.languages.estonian"),
    fil: window.t("constants.languages.filipino"),
    fi: window.t("constants.languages.finnish"),
    fr: window.t("constants.languages.french"),
    ka: window.t("constants.languages.georgian"),
    de: window.t("constants.languages.german"),
    el: window.t("constants.languages.greek"),
    gu: window.t("constants.languages.gujarati"),
    ha: window.t("constants.languages.hausa"),
    he: window.t("constants.languages.hebrew"),
    hi: window.t("constants.languages.hindi"),
    hu: window.t("constants.languages.hungarian"),
    id: window.t("constants.languages.indonesian"),
    ga: window.t("constants.languages.irish"),
    it: window.t("constants.languages.italian"),
    ja: window.t("constants.languages.japanese"),
    kn: window.t("constants.languages.kannada"),
    kk: window.t("constants.languages.kazakh"),
    rw_RW: window.t("constants.languages.kinyarwanda"),
    ko: window.t("constants.languages.korean"),
    ky_KG: window.t("constants.languages.kyrgyzKyrgyzstan"),
    lo: window.t("constants.languages.lao"),
    lv: window.t("constants.languages.latvian"),
    lt: window.t("constants.languages.lithuanian"),
    mk: window.t("constants.languages.macedonian"),
    ms: window.t("constants.languages.malay"),
    ml: window.t("constants.languages.malayalam"),
    mr: window.t("constants.languages.marathi"),
    nb: window.t("constants.languages.norwegian"),
    fa: window.t("constants.languages.persian"),
    pl: window.t("constants.languages.polish"),
    pt_BR: window.t("constants.languages.portugueseBR"),
    pt_PT: window.t("constants.languages.portuguesePOR"),
    pa: window.t("constants.languages.punjabi"),
    ro: window.t("constants.languages.romanian"),
    ru: window.t("constants.languages.russian"),
    sr: window.t("constants.languages.serbian"),
    sk: window.t("constants.languages.slovak"),
    sl: window.t("constants.languages.slovenian"),
    es: window.t("constants.languages.spanish"),
    es_AR: window.t("constants.languages.spanishARG"),
    es_ES: window.t("constants.languages.spanishSPA"),
    es_MX: window.t("constants.languages.spanishMEX"),
    sw: window.t("constants.languages.swahili"),
    sv: window.t("constants.languages.swedish"),
    ta: window.t("constants.languages.tamil"),
    te: window.t("constants.languages.telugu"),
    th: window.t("constants.languages.thai"),
    tr: window.t("constants.languages.turkish"),
    uk: window.t("constants.languages.ukrainian"),
    ur: window.t("constants.languages.urdu"),
    uz: window.t("constants.languages.uzbek"),
    vi: window.t("constants.languages.vietnamese"),
    zu: window.t("constants.languages.zulu"),
  }
);

export const [livechatCallcenterType, livechatCallcenterTypeOptions, livechatCallcenterTypeMap] = ConstantHelper.typify(
  {
    FIFO: "FIFO",
    Pool: "Pool",
  }
);

export const [llmType, llmTypeOptions, llmTypeMap] = ConstantHelper.typify({
  Gemini: "Gemini",
  OpenAI: "OpenAI",
  Groq: "Groq",
});

export const [livechatAgentStatus, livechatAgentStatusOptions, livechatAgentStatusMap] = ConstantHelper.typify({
  AV: window.t("constants.livechatAgentStatus.available"),
  UN: window.t("constants.livechatAgentStatus.unavailable"),
});

export const [chatbotSessionPlatform, chatbotSessionPlatformOptions, chatbotSessionPlatformMap] = ConstantHelper.typify(
  {
    WHAT: "WhatsApp",
    TELE: "Telegram",
    DISC: "Discord",
    SLAC: "Slack",
    TEA: "Teams",
    WEB: "Web",
    AND: "Android",
    IOS: "iOS",
    INST: "Instagram",
    MES: "Messenger",
    MOB: "Other Mobile",
  }
);

export const [trendyolDeliveryStatus, trendyolDeliveryStatusOptions, trendyolDeliveryStatusMap] = ConstantHelper.typify(
  {
    SUGGESTED: "Suggested",
    SUBMITTED: "Submitted",
    AGENT_APPROVED: "Agent Approved",
    SENT: "Sent",
  }
);

export const chatbotInteraction = {
  PRODUCT_OPEN: 0,
  PRODUCT_VIEW_10: 1,
  PRODUCT_VIEW_30: 2,
  PRODUCT_VIEW_60: 3,
  PRODUCT_SEARCH: 4,
  CATEGORY_VIEW: 5,
  CART_ADD: 6,
  CART_REMOVE: 7,
  CART_PURCHASE: 8,
  ACTIVE_TAB: 9,
  CHATBOX_MINIMIZE: 10,
  CHATBOX_MAXIMIZE: 11,
  CHATBOT_PRODUCT_QUESTION: 12,
  CHATBOT_PRODUCT_SEARCH: 13,
  CHATBOT_PRODUCT_VIEW: 14,
  UPDATE_CUSTOMER_INFO: 15,
};

export const chatbotInteractionMap = {
  [chatbotInteraction.PRODUCT_OPEN]: "Product Open",
  [chatbotInteraction.PRODUCT_VIEW_10]: "Product View 10",
  [chatbotInteraction.PRODUCT_VIEW_30]: "Product View 30",
  [chatbotInteraction.PRODUCT_VIEW_60]: "Product View 60",
  [chatbotInteraction.PRODUCT_SEARCH]: "Product Search",
  [chatbotInteraction.CATEGORY_VIEW]: "Category View",
  [chatbotInteraction.CART_ADD]: "Cart Add",
  [chatbotInteraction.CART_REMOVE]: "Cart Remove",
  [chatbotInteraction.CART_PURCHASE]: "Cart Purchase",
  [chatbotInteraction.ACTIVE_TAB]: "Active Tab",
  [chatbotInteraction.CHATBOX_MINIMIZE]: "Chatbox Minimize",
  [chatbotInteraction.CHATBOX_MAXIMIZE]: "Chatbox Maximize",
  [chatbotInteraction.CHATBOT_PRODUCT_QUESTION]: "Chatbot Product Question",
  [chatbotInteraction.CHATBOT_PRODUCT_SEARCH]: "Chatbot Product Search",
  [chatbotInteraction.CHATBOT_PRODUCT_VIEW]: "Chatbot Product View",
  [chatbotInteraction.UPDATE_CUSTOMER_INFO]: "Update Customer Info",
};

export const chatbotInteractionOptions = Object.entries(chatbotInteractionMap).map(([value, label]) => ({
  value,
  label,
}));

// TURKISH = "TR"
//     ENGLISH = "EN"
//     GERMAN = "DE"
//     GREEK = "EL"
//     ARABIC = "AR"
//     UKRAINE = "UK"
//     RUSSIAN = "RU"
//     PERSIAN = "FA"
//     FRENCH = "FR"
//     DUTCH = "NL"

export const [chatbotPreferredLanguage, chatbotPreferredLanguageOptions, chatbotPreferredLanguageMap] =
  ConstantHelper.typify({
    TR: window.t("common.turkish"),
    EN: window.t("common.english"),
    DE: window.t("common.german"),
    EL: window.t("common.greek"),
    AR: window.t("common.arabic"),
    UK: window.t("common.ukraine"),
    RU: window.t("common.russian"),
    FA: window.t("common.persian"),
    FR: window.t("common.french"),
    NL: window.t("common.dutch"),
  });

export const getDefaultLivechatFilter = (projectId) => {
  return [
    {
      type: "options",
      key: "project_ids",
      label: "Projects",
      multiple: true,
      value: [projectId],
      lookupKey: "in",
      lookupKeys: ["in"],
      defaultLookupKey: "in",
    },
  ];
};

// if (options && typeof options === "object" && Object.keys(options)?.length) {
//   if (options?.filters && Array.isArray(options?.filters)) {
//     // filter type changed single dimension array to object[projectId:Array] format
//     options.filters = {};
//   } else {
//     options.filters = options.filters || {};
//   }
// } else {
//   options = { filters: {} };
// }
// let targetProjectFilterObj = options.filters[currentProject?.id] || [];
// const projectFilterKey = "project_ids";
// const projectFilterLookupKey = "in";
// const targetProjectFilterIndex = targetProjectFilterObj.findIndex(
//   (filter) => filter.key === projectFilterKey && filter.lookupKey === projectFilterLookupKey
// );
// if (targetProjectFilterIndex > -1) {
//   targetProjectFilterObj = targetProjectFilterObj.filter((i, index) => index !== targetProjectFilterIndex);
// }

// const initProjectFilter = getDefaultLivechatFilter(currentProject?.id)[0];
// targetProjectFilterObj.push(initProjectFilter);
// options.filters[currentProject?.id] = targetProjectFilterObj;
export const getLivechatFilterWithProjectFilterOverride = (projectId, filters = {}) => {
  let targetProjectFilterObj = [...(filters[projectId] || [])];
  const projectFilterKey = "project_ids";
  const projectFilterLookupKey = "in";
  const targetProjectFilterIndex = targetProjectFilterObj.findIndex(
    (filter) => filter.key === projectFilterKey && filter.lookupKey === projectFilterLookupKey
  );
  if (targetProjectFilterIndex > -1) {
    targetProjectFilterObj = targetProjectFilterObj.filter((i, index) => index !== targetProjectFilterIndex);
  }

  const initProjectFilter = getDefaultLivechatFilter(projectId)[0];
  targetProjectFilterObj.push(initProjectFilter);
  filters[projectId] = targetProjectFilterObj;
  return filters;
};

export const [chatbotAgentVisibilityType, chatbotAgentVisibilityTypeOptions, chatbotAgentVisibilityTypeMap] =
  ConstantHelper.typify({
    All: window.t("constants.chatbotVisibilityType.all"),
    Assigned: window.t("constants.chatbotVisibilityType.assigned"),
    Group: window.t("constants.chatbotVisibilityType.group"),
  });

export const [livechatSortMode, livechatSortModeOptions, livechatSortModeMap] = ConstantHelper.typify({
  creation: window.t("constants.livechatSortMode.firstSessionOnTop"),
  creationDesc: window.t("constants.livechatSortMode.lastSessionOnTop"),
  lastMessage: window.t("constants.livechatSortMode.firstMessageOnTop"),
  lastMessageDesc: window.t("constants.livechatSortMode.lastMessageOnTop"),
});

export const [agentOfflineTerminateMode, agentOfflineTerminateModeOptions, agentOfflineTerminateModeMap] =
  ConstantHelper.typify({
    direct_to_queue: window.t("constants.offlineTerminateMode.directToQueue"),
    terminate_session: window.t("constants.offlineTerminateMode.terminateSession"),
    direct_to_bot: window.t("constants.offlineTerminateMode.directToBot"),
    stay_in_session: window.t("constants.offlineTerminateMode.stayInSession"),
    transfer_agent: window.t("constants.offlineTerminateMode.transferAgent"),
  });
